import { authClient, API } from '../index'
import { uploadSingleFile } from "../files";


// Get all technologies
export const getAllActiveTechnologies = () => {
    return authClient().get(`${API}/technology/`)
}

export const getAllTechnologies = () => {
    return authClient().get(`${API}/technology/?getDisabled=true`)
}

// Get technology by id
export const getTechnologyById = (id) => {
    return authClient().get(`${API}/technology/${id}`)
}

// Create technology
export const postTechnology = async (technology, logo) => {
    if (logo) {
        const response = await uploadSingleFile(logo, "logos");
        technology.logoURL = response?.data?.fileURL;
    }

    return authClient().post(`${API}/technology/`, technology)
}

// Update text
export const updateTechnology = async (id, technology, logo) => {
    if (logo) {
        const response = await uploadSingleFile(logo, "logos");
        technology.logoURL = response?.data?.fileURL;
    }


    return authClient().put(`${API}/technology/${id}`, technology)
}

// Change status technology
export const changeStatusTechnology = async (id, active) => {
    return authClient().put(`${API}/technology/change-status/${id}`, { active });
};


// Delete technology
export const deleteTechnology = (id) => {
    return authClient().delete(`${API}/technology/${id}`)
}

